<template>
  <div class="loading-animation">
    <div class="spinner-wrapper">
      <spinner size="massive"/>
    </div>
  </div>
</template>

<script>
import Spinner from "vue-simple-spinner";

export default {
  name: "loading-animation",
  components: {
    Spinner,
  },
};
</script>